import { call, put } from "redux-saga/effects";
import { apiGeneral, notify } from "services";
import { IUpdateRequest } from "interfaces/update-duck";
import { requestErrorHandler } from "utils";
import { ResendAlertActions } from "store/ducks/settings/alert-email-logs";

export function* resendAlertRequest(action: any) {
  try {
    const { id, putData, onSuccess } = action as IUpdateRequest;

    const { data: responseBody } = yield call(
      apiGeneral.put,
      `/alert-email-log-resend/${id}`,
      putData
    );

    const { data } = responseBody;
    yield put(ResendAlertActions.success(data));
    notify("success", "Alerta reenviado com sucesso");
    if (onSuccess) onSuccess();
  } catch (error) {
    const { errorMessage } = requestErrorHandler(error);
    notify("error", errorMessage);
    yield put(ResendAlertActions.failure(errorMessage));
  }
}
